import { apiPath } from "../../lib/apiPath";
import type { WorldMapClaimResult, WorldMapOwnerInfo, WorldMapSnapshot } from "./types";

const jsonHeaders = { "Content-Type": "application/json", Accept: "application/json" };

export async function fetchWorldMap(): Promise<WorldMapSnapshot> {
  const r = await fetch(apiPath("/api/world-map"), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!r.ok) throw new Error(`world-map ${r.status}`);
  return (await r.json()) as WorldMapSnapshot;
}

export async function postWorldMapClaim(blockId: string): Promise<WorldMapClaimResult> {
  const r = await fetch(apiPath("/api/world-map"), {
    method: "POST",
    credentials: "include",
    headers: jsonHeaders,
    body: JSON.stringify({ action: "claim", blockId }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw Object.assign(new Error(data.error || `claim ${r.status}`), { data, status: r.status });
  return data as WorldMapClaimResult;
}

export async function fetchWorldMapOwnerInfo(userId: string): Promise<WorldMapOwnerInfo> {
  const r = await fetch(apiPath("/api/world-map"), {
    method: "POST",
    credentials: "include",
    headers: jsonHeaders,
    body: JSON.stringify({ action: "owner-info", userId }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw Object.assign(new Error(data.error || `owner ${r.status}`), { data, status: r.status });
  return data as WorldMapOwnerInfo;
}
